import { combineReducers } from 'redux';
import app from './appReducer';
import products from './productReducer';

export default combineReducers({ app, products });
